import { SupportedDocuments } from "../API/PeppolDirectory";

export interface consultantActivityPeriode {
    dateDebut: string | null,
    dateFin: string | null,
}

export interface ConsultantPeppolIdentifier {
    peppolIdentifier: string,
}

export interface Consultant {
    consultantid: string | null,
    displayName: string | null,
    email: string | null,
    o365id: string | null,
    isActive: boolean,
    isAdmin: boolean,
    canEnterDocuments: boolean,
    canManageConsultantDocuments: boolean,
    receiveNotification: boolean,
    receiveInvoiceEmails: boolean,
    canEnterTimeSheet: boolean,
    photo?: any,
    companyName: string | null,
    vat: string | null,
    iban: string | null,
    bic: string | null,
    address: string | null,
    address2: string | null,
    address3: string | null,
    postalCode: string | null,
    city: string | null,
    country: string | null,
    consultantActivityPeriodes?: consultantActivityPeriode[],
    firstName: string | null,
    lastName: string | null,
    phoneNumber: string | null,
    companyNumber: string | null,
    privateEmail: string | null,
    language: string | null,
    countryCode: string | null,
    website: string | null,
    peppolRegisterProd: boolean,
    peppolRegisterDev: boolean,
    peppolStatus?: PeppolStatus,
    ownPeppolDocsReceptionTeamsNotif: boolean,
    ownPeppolDocsReceptionEmailNotif: boolean,
    neomyticPeppolDocsReceptionTeamsNotif: boolean,
}

export interface ConsultantInvoice {
    consultantInvoiceid: string | null,
    consultantid: string | null,
    invoiceRef: string | null,
    creationDate: string | null,
    sharePointFileUniqueId: string | null,
    invoiceFileExist: boolean,
    amount: number,
    periode: string | null,
    paymentDate: string | null,
    description: string | null,
    lock: boolean,
    vatcode: number | null,
    documentDate: string | null,
    accountingRef: string | null,
}

export interface FixePriceConsultant {
    consultantid: string | null,
    dateDebut: string | null,
    dateFin: string | null,
    price: number,
    priceType: string,
}

export interface ConsultantDocument {
    consultantdocumentid: string,
    consultantid: string | null,
    consultantidPublisher: string | null,
    createDate: string | null,
    lastUpdateDate: string | null,
    documentSharePointFileUniqueId: string,
    documentSharePointFileOriginalName: string,
    documentTypeId: number,
    documentDate: string | null,
    documentSource: string | null,
    documentAmount: number | null,
    lock: boolean,
    accountingRef: string | null,
    description: string | null,
    consultantInvoiceid?: string | null,
}

export interface ConsultantDocumentPatch {
    consultantdocumentid: string,
    documentTypeId: number,
    documentDate: string,
    documentSource: string,
    documentAmount: number | null,
    lock: boolean,
    accountingRef: string | null,
    description: string | null,
}

export interface ConsultantPeppolIdentifierWithStatus {
    isRegistered: boolean,
    peppolIdentifier: string,
    supportedDocuments?: SupportedDocuments,
}
export interface PeppolStatus {
    prod: ConsultantPeppolIdentifierWithStatus[],
    test: ConsultantPeppolIdentifierWithStatus[],
}

export interface ConsultantPeppolReceivedDoc {
    peppolReceivedDocsId: string,
    consultantid: string,
    supplierEndpointId: string,
    registrationName: string,
    id: string,
    issueDate: string,
    payableAmount: number,
    taxInclusiveAmount: number,
    lock: boolean,
    accountingRef: string | null,
    description: string | null,
    isTestDoc: boolean,
}
export interface ConsultantPeppolReceivedInvoice extends ConsultantPeppolReceivedDoc {
    peppolReceivedInvoiceId: string,
    dueDate?: string | null,
    status?: number | null,
    paymentDate?: string | null,
}

export interface ConsultantPeppolReceivedCreditNote extends ConsultantPeppolReceivedDoc {
    peppolReceivedCreditNoteId: string,
}

export interface PeppolInvoiceResponse {
    timeStamp: string,
    code: string,
    peppolReceivedDocsId: string,
}
export interface PeppolSendedDoc {
    peppolSendedDocsId: string,
    peppolDoc: string,
    peppoDocSendDate: string,
    consultantid: string,
    peppolDocType: string,
    sendStatus: boolean,
    sendMessage: string | null,
    sendConsultantid: string,
    isTestDoc: boolean,
    sendStatusMessage: string,
    peppolSendedDocReplies?: PeppolInvoiceResponse[],
}

export const NeomyticConsultantID = "22F53E33-130F-447A-98BA-7BC18262FE5B";
export function IsNeomyticConsultant(consultantid?: string): boolean {
    if (consultantid && consultantid.toUpperCase() === NeomyticConsultantID) {
        return true;
    }
    return false;
}